// Critique sorun listesi — spec §7.2b. Editör AÇIK kalır; liste editörün üstünde.
// Canlı quote doğrulaması (codex #2): güncel editör içeriğine karşı FE-side.
// norm() Task 7 parseCritiqueOutput'taki normalizeWs ile BİRE BİR aynı olmalı —
// aksi halde depolanan quoteVerified ile canlı doğrulama tutarsız çıkar.
import { useMemo, useState } from "react";
import type { QcIssue, ReviewSection } from "@mahir/shared";

const SEV: Record<QcIssue["severity"], { icon: string; label: string }> = {
  high: { icon: "🔴", label: "Yüksek" },
  medium: { icon: "🟡", label: "Orta" },
  low: { icon: "⚪", label: "Düşük" },
};

// Task 7 normalizeWs ile aynı: whitespace daralt + trim + lowercase.
const norm = (s: string): string => s.replace(/\s+/g, " ").trim().toLowerCase();

export function CritiquePanel({
  section,
  editorContent,
  busy,
  onClose,
}: {
  section: ReviewSection;
  editorContent: string; // localContent — canlı doğrulama buna karşı
  busy: boolean;
  onClose: () => void;
}): JSX.Element {
  const [collapsed, setCollapsed] = useState(false);
  const issues = section.qcMeta?.issues ?? [];
  const normContent = useMemo(() => norm(editorContent), [editorContent]);
  const meta = section.qcMeta;

  return (
    <div
      className="mb-3 rounded-md"
      style={{ border: "1px solid var(--color-border)", background: "var(--color-surface)" }}
    >
      <div className="flex items-center justify-between px-3 py-2">
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="text-sm"
          style={{ fontWeight: 600 }}
        >
          {collapsed ? "▸" : "▾"} 🔍 Sorun Listesi ({issues.length})
          {meta && (
            <span
              className="ml-2 text-xs"
              style={{ color: "var(--color-text-3)", fontWeight: 400 }}
            >
              {meta.promptName} · {meta.model} · ${meta.costUsd.toFixed(4)}
            </span>
          )}
        </button>
        <button
          onClick={onClose}
          disabled={busy}
          className="px-2 py-1 rounded text-xs disabled:opacity-50"
          style={{ border: "1px solid var(--color-border)", color: "var(--color-text-2)" }}
        >
          Kapat
        </button>
      </div>
      {!collapsed && issues.length === 0 && (
        <p className="px-3 pb-3 text-sm" style={{ color: "var(--color-success)" }}>
          ✓ Seçilen denetimde sorun bulunamadı
        </p>
      )}
      {!collapsed &&
        issues.map((it, i) => {
          const inText = normContent.includes(norm(it.quote));
          const stale = !inText; // düzeltildi ya da metinden çıktı
          return (
            <div
              key={i}
              className="px-3 py-2 border-t"
              style={{ borderColor: "var(--color-border)", opacity: stale ? 0.5 : 1 }}
            >
              <div className="text-xs mb-1">
                {SEV[it.severity].icon} <strong>{SEV[it.severity].label}</strong>
                {it.quoteVerified === false && !stale && (
                  <span className="ml-2" style={{ color: "var(--color-warning)" }}>
                    ⚠ alıntı metinde doğrulanamadı
                  </span>
                )}
                {stale && (
                  <span className="ml-2" style={{ color: "var(--color-success)" }}>
                    ✓ ele alındı / metinden çıktı
                  </span>
                )}
              </div>
              <div
                className="text-xs px-2 py-1 rounded mb-1"
                style={{ fontFamily: "var(--font-mono)", background: "var(--color-bg)" }}
              >
                “{it.quote}”
              </div>
              <p className="text-sm">{it.issue}</p>
              <p className="text-xs mt-0.5" style={{ color: "var(--color-text-2)" }}>
                Öneri: {it.suggestion}
              </p>
            </div>
          );
        })}
    </div>
  );
}
